module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "crew"
  }, [_c('h3', {
    staticClass: "crew__title"
  }, [_vm._v("Члены команды:")]), _c('div', {
    staticClass: "crew__layout"
  }, [_c('MentoringMember', {
    attrs: {
      "sidebarChild": true,
      "name": _vm.child.name,
      "lastname": _vm.child.lastname,
      "gender": _vm.child.gender,
      "photo": _vm.child.photo
    }
  }), _vm._l((_vm.crew), function(item, index) {
    return _c('MentoringMember', {
      key: index,
      attrs: {
        "name": item.name,
        "lastname": item.lastname,
        "gender": item.gender,
        "photo": item.photo
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e6a6ad4e","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/teamcard/components/crew/MentoringCrew.vue
// module id = 73c621720c422acb8354
// module chunks = 89